import { render, staticRenderFns } from "./AutoRewardsSelection.vue?vue&type=template&id=4c3beba0"
import script from "./AutoRewardsSelection.vue?vue&type=script&lang=js"
export * from "./AutoRewardsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports